import { ModelBase } from '../../abstract/model-base.model';
import { Account } from '../../accounting/account.model';
import { Journal } from '../../accounting/journal.model';

export class PaymentProvider extends ModelBase {

    static override CLASS_NAME: string = 'PaymentProvider';

    private _account!: Account;
    private _journal!: Journal;
    private _label!: string;

    public get account(): Account {
        return this._account;
    }

    public set account(value: any) {
        this._setValue('_account', value, 'Account');
    }

    public get journal(): Journal {
        return this._journal;
    }

    public set journal(value: any) {
        this._setValue('_journal', value, 'Journal');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }
}
